export default __webpack_public_path__ + "static/media/18.9314af04.jpg";